function forgotPassword_panel() {
  document.getElementById("loginPanelGroup").classList.add("hidden");
  document.getElementById("loginResetGroup").classList.remove("hidden");
}
function login_panel() {
  document.getElementById("loginPanelGroup").classList.remove("hidden");
  document.getElementById("loginResetGroup").classList.add("hidden");
}
function toggleMobileMenu(event_target) {
  const mobileMenu = document.getElementById("mobile-menu");
  const menuContainer = mobileMenu.querySelector(".mobile-menu-container");
  menuContainer.classList.toggle("active");
  if(menuContainer.classList.contains("active")) {
    modalDisableScroll();
  } else {
    modalEnableScroll();
  }
}
function toggleCategory(event_target) {
  const category = event_target.parentElement;
  const categoryContent = category.querySelector(".category-content");
  categoryContent.classList.toggle("active");
}
function toggleSubCategory(event_target) {
  const subCategory = event_target.parentElement;
  const subCategoryContent = subCategory.querySelector(".subcategory-content");
  const categoryContent = subCategory.parentElement;
  subCategoryContent.classList.toggle("active");
  categoryContent.scrollTop = 0;

}
function closeCategory(event_target) {
  const category = event_target.parentElement.parentElement;
  category.classList.remove("active");
}
